
import React from 'react';
import { Loader } from 'lucide-react';

interface ImageSingleViewProps {
  originalUrl: string;
  fileName: string;
  isLoadingOriginal: boolean;
  status: 'pending' | 'processing' | 'completed' | 'failed';
  isPremium?: boolean;
}

const ImageSingleView = ({ 
  originalUrl, 
  fileName, 
  isLoadingOriginal, 
  status, 
  isPremium = false 
}: ImageSingleViewProps) => {
  return (
    <div className="relative aspect-[4/3] bg-gray-100">
      {isLoadingOriginal ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <Loader className="w-8 h-8 text-gray-400 animate-spin" />
        </div>
      ) : (
        <img
          src={originalUrl}
          alt={fileName}
          className="w-full h-full object-cover"
        />
      )}
      
      {/* Status Overlay */}
      {status === 'processing' && (
        <div className={`absolute inset-0 bg-opacity-20 flex items-center justify-center ${
          isPremium ? 'bg-purple-500' : 'bg-blue-500'
        }`}>
          <div className="bg-white rounded-full p-3">
            <Loader className={`w-6 h-6 animate-spin ${
              isPremium ? 'text-purple-500' : 'text-blue-500'
            }`} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageSingleView;
